import App from '@/App.tsx';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
